import { useMutation } from '@apollo/client'
import { Button } from '@winnin/winnin_ui.components.button'
import { useToast } from '@winnin/winnin_ui.components.toast'

import { T, useTranslate } from 'lib/tolgee'
import {
  getJobPinInput,
  getPinChangesFromItems,
  updateWorkspaceJobPinsCache,
} from 'modules/dashboard/common/dashboard.utils'

import { SAVE_PINS_TO_JOB_FOLDERS } from './query'

import './index.scss'

const TOLGEE_PREFIX = 'UndoRemoveToast'

export default function UndoRemoveToast({ removedData }) {
  const { createToast } = useToast()
  const t = useTranslate()

  const [savePintsToJobFolders] = useMutation(SAVE_PINS_TO_JOB_FOLDERS, {
    onCompleted: data => {
      if (data?.createWorkspaceJobPins?.success)
        createToast({
          content: t({
            defaultValue: 'The content was added back to your dashboard.',
            key: `${TOLGEE_PREFIX}-successToast-asDashboard`,
          }),
        })
    },
    onError: error => console.error('Error @SAVE_PINS_TO_JOB_FOLDERS >>>>', error),
    refetchQueries: [
      'getWorkspaceJob',
      'getJobCretors',
      'getJobTopics',
      'getJobVideos',
      'getFolder',
      'getJobData',
      'getJobAllEntities',
    ],
    update: cache => {
      if (!removedData?.jobId) return

      const shouldUpdateJobCache = removedData?.isCheckboxActive || !removedData?.folderIds?.length

      if (shouldUpdateJobCache) {
        const pinChanges = getPinChangesFromItems(removedData?.pinsList)
        updateWorkspaceJobPinsCache(cache, removedData.jobId, pinChanges, 'add')
      }
    },
  })

  const addBackToJob = async () => {
    const selectedItemsBar = removedData?.pinsList
    const inputVariables = selectedItemsBar.map(item => getJobPinInput(item, removedData?.folderIds))

    const cleanInputVariables = inputVariables.filter(item => item.entityId)

    const variables = {
      createWorkspaceJobPinInput: cleanInputVariables,
      workspaceJobId: removedData?.jobId,
    }

    await savePintsToJobFolders({
      variables,
    })
  }
  return (
    <div className="UndoRemoveToast-wrapper">
      {removedData?.folderIds?.length || removedData?.isCheckboxActive
        ? t({
            defaultValue:
              '{count, plural, one {# referência foi removida} other {# referências foram removidas}} da pasta.',
            parameters: { count: removedData?.pinsList?.length },
            key: `${TOLGEE_PREFIX}-folderToastMessage`,
          })
        : t({
            defaultValue:
              '{count, plural, one {# referência foi removida} other {# referências foram removidas}} do dashboard.',
            parameters: { count: removedData?.pinsList?.length },
            key: `${TOLGEE_PREFIX}-jobToastMessage-asDashboard`,
          })}
      <Button onClick={addBackToJob} appearance="link">
        <T keyName={`${TOLGEE_PREFIX}-undo`}>Desfazer</T>
      </Button>
    </div>
  )
}
